module.exports = __webpack_public_path__ + "img/c07_unitstartechlogthrowerchampion_Normal_ua.1289e3f2.webp";